import { useState } from 'react';
import { Menu, Sparkles, X } from 'lucide-react';
import { profile } from '../data/content';

const links = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Projects', href: '#projects' },
  { label: 'Services', href: '#services' },
  { label: 'Order', href: '#order' },
  { label: 'Contact', href: '#contacts' },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <a className="brand" href="#home" onClick={() => setOpen(false)}>
        <span className="brand-mark">
          <Sparkles size={18} />
        </span>
        <span>{profile.nickname}</span>
      </a>

      <nav className={`nav-links ${open ? 'is-open' : ''}`}>
        {links.map((link) => (
          <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
            {link.label}
          </a>
        ))}
      </nav>

      <a className="header-action" href="#checkout">
        Checkout
      </a>

      <button className="menu-button" type="button" aria-label="Toggle menu" onClick={() => setOpen((value) => !value)}>
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>
    </header>
  );
}
